import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import axiosInstance from "../api/axiosInstance";
 import Swal from "sweetalert2";
import axios from "../api/axiosInstance";
export default function AppHeader() {

  const navigate = useNavigate();

  const [adminPhone, setAdminPhone] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
	const [cartCount, setCartCount] = useState(0);
  const menuRef = useRef(null);

  const menuItems = [
    { label: "🏠 Home", action: () => navigate("/customer-dashboard") },
    { label: "💊 Medicines", action: () => navigate("/products") },
    { label: "🧾 My Orders", action: () => navigate("/orders") },
    { label: "👤 Profile", action: () => navigate("/profile") },
    { label: "🚪 Logout", action: handleLogout }
  ];


 

async function handleLogout() {
  const result = await Swal.fire({
    title: "Logout?",
    text: "Do you want to logout?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#0284C7",
    cancelButtonColor: "#aaa",
    confirmButtonText: "Yes, Logout",
    cancelButtonText: "Cancel"
  });

  if (result.isConfirmed) {
    localStorage.clear();
    navigate("/", { replace: true });
  }
}






  function logout() {
    localStorage.clear();
    navigate("/");
  }


useEffect(() => {

  fetchCartCount();

  const interval = setInterval(() => {
    fetchCartCount();
  }, 1500);

  return () => clearInterval(interval);

}, []);

const fetchCartCount = async () => {
  try {
    const res = await axios.get("/cart/");
    console.log("CART DATA:", res.data);

    if (Array.isArray(res.data)) {
      // quantity based count
      const total = res.data.reduce((sum, item) => sum + (item.quantity || 1), 0);
      setCartCount(total);
    } else if (res.data.items) {
      setCartCount(res.data.items.length);
    } else if (res.data.cart_items) {
      setCartCount(res.data.cart_items.length);
    } else {
      setCartCount(0);
    }

  } catch (err) {
    console.error("Cart fetch error", err);
  }
};


  useEffect(() => {
    axiosInstance
      .get("/admin/emergency-contact/get/")
      .then((res) => setAdminPhone(res.data.phone))
      .catch(() => setAdminPhone(""));
  }, []);

  useEffect(() => {
    axiosInstance
      .get("/notifications/unread-count/")
      .then((res) => setUnreadCount(res.data.count || 0))
      .catch(() => setUnreadCount(0));
  }, []);

  useEffect(() => {

    const handler = (e) => {

      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }

    };

    document.addEventListener("click", handler);

    return () => document.removeEventListener("click", handler);

  }, []);

  return (
    <>
      <style>
        {`

.header{

position:fixed;

top:env(safe-area-inset-top);

left:0;
width:100%;

background:#ffffff;

box-shadow:0 2px 8px rgba(0,0,0,0.1);

z-index:9999;

padding:
calc(10px + env(safe-area-inset-top))
12px
10px
12px;

display:flex;
align-items:center;
justify-content:space-between;

box-sizing:border-box;

}

.left-section{

display:flex;
align-items:center;
gap:10px;
min-width:0;

}

.hamburger{

width:32px;
height:26px;
border:none;
background:none;
cursor:pointer;
display:flex;
flex-direction:column;
justify-content:space-between;
padding:0;

}

.ham-line{

height:3px;
background:#333;
border-radius:2px;

}

.dropdown{

position:absolute;
top:40px;
left:0;
background:white;
border-radius:10px;
box-shadow:0 6px 20px rgba(0,0,0,0.15);
width:200px;
padding:6px 0;

}

.dropdown-item{

padding:10px 14px;
cursor:pointer;
font-size:14px;

}

.dropdown-item:hover{

background:#f5f5f5;

}

.top-links{

display:flex;
gap:16px;
font-size:14px;
white-space:nowrap;

}

.top-links a{

text-decoration:none;
color:#6a1b9a;
font-weight:600;

}

.notification{

position:relative;
cursor:pointer;
font-size:22px;
flex-shrink:0;

}

.badge{

position:absolute;
top:-5px;
right:-8px;

background:red;
color:white;

border-radius:50%;

font-size:10px;
font-weight:bold;

min-width:16px;
height:16px;

display:flex;
align-items:center;
justify-content:center;

padding:1px 4px;

}





.right-icons{

display:flex;
align-items:center;
justify-content:flex-end;
gap:14px;
min-width:70px;

}

.notification,
.cart-icon{

position:relative;
cursor:pointer;
font-size:20px;

width:24px;
height:24px;

display:flex;
align-items:center;
justify-content:center;

flex-shrink:0;

}
/* MOBILE */

@media(max-width:768px){

.top-links{

display:none;

}

}

/* SMALL MOBILE */

@media(max-width:420px){

.header{

padding:8px 10px;

}



}

/* PAGE SPACE */

.page-space{

height:90px;

}

        `}
      </style>

      <div className="header">

        {/* LEFT */}
        <div className="left-section">

          <div ref={menuRef} style={{ position: "relative" }}>

            <button
              className="hamburger"
              onClick={(e) => {
                e.stopPropagation();
                setMenuOpen((s) => !s);
              }}
            >
              <div className="ham-line"></div>
              <div className="ham-line"></div>
              <div className="ham-line"></div>
            </button>

            {menuOpen && (
              <div className="dropdown">

                {menuItems.map((it) => (

                  <div
                    key={it.label}
                    className="dropdown-item"
                    style={{ color: it.danger ? "#d93025" : "#111" }}
                    onClick={() => {
                      setMenuOpen(false);
                      setTimeout(() => it.action(), 80);
                    }}
                  >
                    {it.label}
                  </div>

                ))}

              </div>
            )}

          </div>

          {/* LINKS (DESKTOP ONLY) */}

          <div className="top-links">

            <Link to="/requested-medicines">
              ⭐ Requested Medicine
            </Link>

            <a href={`tel:${adminPhone}`}>
              🚨 Emergency Call
            </a>

            <a
              href="https://www.google.com/maps/dir/?api=1&destination=28.329481,79.397409"
              target="_blank"
              rel="noopener noreferrer"
            >
              📍 Locate Store
            </a>

          </div>

        </div>

        {/* RIGHT */}

<div className="right-icons">

  <div
    className="notification"
    onClick={() => navigate("/notifications")}
  >
    🔔

    {unreadCount > 0 && (
      <span className="badge">
        {unreadCount}
      </span>
    )}

  </div>

  <div
    className="cart-icon"
    onClick={() => navigate("/cart")}
  >
    🛒

    {cartCount > 0 && (
      <span className="badge">
        {cartCount}
      </span>
    )}

  </div>

</div>








      </div>





      <div className="page-space"></div>

    </>
  );

}

